import { render, staticRenderFns } from "./IQCReportDetail.vue?vue&type=template&id=2556418e"
import script from "./IQCReportDetail.vue?vue&type=script&lang=js"
export * from "./IQCReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports